var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cardContent" },
    [
      _c(
        "vue-seamless-scroll",
        {
          staticClass: "tableBody",
          attrs: { data: _vm.list, "class-option": _vm.classOption },
        },
        [
          _c(
            "ul",
            _vm._l(_vm.list, function (item, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "content",
                  on: {
                    click: function ($event) {
                      return _vm.showDt(item)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "flex mainDiv" }, [
                    _c("div", { staticClass: "leftDiv" }, [
                      _c("img", {
                        attrs: { src: _vm.$config.imgIp + item.logo },
                      }),
                    ]),
                    _c("div", { staticClass: "rightDiv flex" }, [
                      _c("div", { staticClass: "rightTop" }, [
                        _vm._v(_vm._s(item.name)),
                      ]),
                      _c("div", { staticClass: "rightBot" }, [
                        _c("p", { staticClass: "address" }, [
                          _vm._v("企业地址：" + _vm._s(item.address)),
                        ]),
                        _c("p", [_vm._v("联系人：" + _vm._s(item.linkman))]),
                        _c("p", [
                          _vm._v("联系方式：" + _vm._s(item.linkmanPhone)),
                        ]),
                      ]),
                    ]),
                  ]),
                ]
              )
            }),
            0
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }